import $ from 'jquery';

/**
 * Add / Remove extra Delegates
 */
class EventDelegates {
    constructor() {
        // Booker as Delegate 1
        this.$iAmAttending = $('.js-i-am-attending input');
        this.$bookerAsDelegateFields = $('.js-booker-as-delegate-fields');
        this.$bookerAsDelegatePermission = $('.js-booker-as-delegate-permission input');

        // Extra Delegates
        this.$addButton = $('.js-add-delegate');
        this.$removeButton = $('.js-remove-delegate');
        this.$extraDelegates = $('.js-delegate-wrapper');

        // Trigger check on load
        this.toggleDelegate1();

        // Trigger check on change
        this.$iAmAttending.on('change', $.proxy(this.toggleDelegate1, this));

        // Extra Delegate Events
        this.$addButton.on('click', $.proxy(this.addDelegate, this));
        this.$removeButton.on('click', $.proxy(this.removeDelegate, this));

        // Show Extra Delegates that are not empty on load
        $(window).on('load', () => {
            this.$extraDelegates.each(function () {
                if ($(this).find('input').first().val().length) {
                    $(this).removeClass('is-hidden');
                }
            });
        });
    }

    addDelegate() {
        const $firstHiddenDelegate = this.$extraDelegates.filter(':not(:visible)').first();

        if ($firstHiddenDelegate.length) {
            $firstHiddenDelegate.removeClass('is-hidden');
        }

        this.toggleAddButton();
    }

    removeDelegate(e) {
        const $elem = $(e.currentTarget);
        const $delegateToRemove = $elem.closest(this.$extraDelegates);

        if ($delegateToRemove.length) {
            $delegateToRemove.addClass('is-hidden');
        }

        this.toggleAddButton();
    }

    toggleAddButton() {
        if (this.$extraDelegates.filter(':not(:visible)').length === 0) {
            this.$addButton.hide();
        } else {
            this.$addButton.show();
        }
    }

    toggleDelegate1() {
        if (this.$iAmAttending.length) {
            // Check on load
            if (this.$iAmAttending.is(':checked')) {
                this.$bookerAsDelegateFields.addClass('is-hidden');
                this.$bookerAsDelegatePermission.prop('checked', true);
            } else {
                this.$bookerAsDelegateFields.removeClass('is-hidden');
                this.$bookerAsDelegatePermission.prop('checked', false);
            }
        }
    }
}

export default EventDelegates;
